
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '../controlador';
    import atributos from './utiles-detalles-publicacion-atributos.vue';
    import descripcion from './utiles-detalles-publicacion-descripcion.vue';
    import preguntas from './utiles-detalles-publicacion-preguntas.vue';
    import notas from './utiles-detalles-publicacion-notas.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            atributos,
            descripcion,
            preguntas,
            notas,
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Publicacion()
        {
            return this.Controlador.Seleccionada.Publicacion;
        }

        public Modo: string = 'atributos';

        protected Eventos: Function[] = [];
        beforeDestroy()
        {

            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onSeleccionado.subscribe( () =>
            {
                this.Modo = 'atributos';
            } ) );
        }


        Cerrar()
        {
            this.Controlador.Vista.Modo = 'respuestas';
        }
    }
